import React from "react";
import { Link } from "react-router-dom";
import { Leaf, ShieldCheck } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="border-t border-[#BBF7D0] bg-white mt-16" data-testid="app-footer">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-6 flex flex-col gap-3 text-sm">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-[#14532D] font-semibold tracking-wide">
            <Leaf className="h-4 w-4 text-[#15803D]" strokeWidth={2.5} />
            <span data-testid="footer-slogan">{t("footer.slogan")}</span>
          </div>
          <div className="text-xs text-slate-500 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
            <Link to="/legal" data-testid="footer-legal" className="font-semibold text-[#14532D] hover:underline">{t("footer.legal")}</Link>
          </div>
        </div>
        <div
          data-testid="footer-rgpd"
          className="flex items-start gap-2 text-[0.75rem] text-slate-500 border-t border-slate-100 pt-3"
        >
          <ShieldCheck className="h-3.5 w-3.5 text-[#15803D] mt-0.5 shrink-0" />
          <span>{t("footer.rgpd")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
